import React from 'react';
import { FormattedMessage } from 'react-intl';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import EntityTable from '../common/entity/entityTable';

import GlassPopup from '../common/interface/glassPopup';

const LoadDataInfoPopup = props => {
  const {
    handleShowPopup,
    handleRefresh,
    fullLoading,
    tableLoading,
    listState,
    handleNextPage,
    handleRowClick,
    popupState
  } = props;
  return (
    <GlassPopup
      className="form_popup notifications_popup"
      title={(<FormattedMessage id={"metricDataAdmin.processingMetricsDataInfo.title"}/>)}
      {...props}
    >
      <div>
        <EntityTable
          entityTableDescriptor={TableDescriptors.processingMetricsImportNotifications}
          data={listState.data}
          loading={tableLoading}
          page={listState.page}
          totalPages={listState.totalPages}
          totalRecords={listState.totalRecords}
          orderBy={listState.orderBy}
          orderByDirection={listState.orderByDirection}
          fetchListChangePage={handleNextPage}
          handleRowClick={handleRowClick}
          hideActions={true}
        />
      </div>
    </GlassPopup>
  );
};

export default LoadDataInfoPopup;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/loadDataInfoPopup.jsx